import apiClient from './client';

export const authApi = {
  login: (credentials) => apiClient.post('/auth/login', credentials),

  register: (userData) => apiClient.post('/auth/register', userData),

  logout: () => apiClient.post('/auth/logout'),

  forgotPassword: (email) => apiClient.post('/auth/forgot-password', { email }),

  resetPassword: (data, resetToken) =>
    apiClient.post(
      '/auth/reset-password',
      data,
      resetToken
        ? {
            headers: {
              Authorization: `Bearer ${resetToken}`,
            },
          }
        : undefined
    ),

  verifyOtp: (data) => apiClient.post('/auth/verify-otp', data),

  resendOtp: (data) => apiClient.post('/auth/resend-otp', data),

  getSession: () => apiClient.get('/auth/session'),

  updateProfile: (data) => apiClient.put('/auth/profile', data),

  changePassword: (data) => apiClient.put('/auth/change-password', data),

  uploadProfileImage: (formData) =>
    apiClient.post('/auth/profile/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  onboard: (data) => apiClient.post('/auth/onboard', data),
};

export default authApi;
